import * as c from 'shared/constants'

export const GA4_MEASUREMENT_ID = 'G-3VVXDRFSS7'

export const ANALYTICS_FEATURES = {
  AUTH: 'auth',
  CUSTOM_SEARCH: 'custom_search',
  DISTRICT_DASHBOARD: 'district_dashboard',
  PROPERTY_LOOKUP: 'property_lookup',
  TABLE: 'table',
  MODAL: 'modal',
}

export const isAnalyticsEnabled = () => c.ENABLE_GOOGLE_ANALYTICS

let ga4Initialized = false
let ga4ScriptLoaded = false
const pendingEvents = []

export const initGa4 = () => {
  if (!isAnalyticsEnabled() || ga4Initialized || typeof window === 'undefined') return

  ga4Initialized = true
  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    window.dataLayer.push(arguments)
  }

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`
  script.onload = () => {
    ga4ScriptLoaded = true
    pendingEvents.splice(0).forEach(({ eventName, params }) => {
      window.gtag('event', eventName, params)
    })
  }
  document.head.appendChild(script)

  window.gtag('js', new Date())
  window.gtag('config', GA4_MEASUREMENT_ID, {
    // Manual page_view via PageViewTracker. Also disable "Page changes based on
    // browser history events" under GA4 Admin → Enhanced measurement to avoid a
    // second automatic page_view (no ep.logged_in) on each history change.
    send_page_view: false,
    anonymize_ip: true,
  })
}

const callGtag = (...args) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args)
  }
}

export const getAuthParams = getState => {
  if (typeof getState !== 'function') {
    return { logged_in: 'false' }
  }

  const auth = getState().auth || {}
  const isLoggedIn = !!(auth.user || auth.access?.token)

  // GA4 often omits boolean false from collect URLs — use strings so ep.logged_in
  // always appears in DevTools and reports.
  return {
    logged_in: isLoggedIn ? 'true' : 'false',
  }
}

const sanitizeParams = params => {
  const clean = {}
  Object.keys(params).forEach(key => {
    const value = params[key]
    if (value !== undefined && value !== null && value !== '') {
      clean[key] = value
    }
  })
  return clean
}

export const trackGa4Event = (eventName, params = {}, getState = null) => {
  if (!isAnalyticsEnabled()) return

  const payload = sanitizeParams({
    ...getAuthParams(getState),
    ...params,
  })

  if (!ga4ScriptLoaded) {
    pendingEvents.push({ eventName, params: payload })
    return
  }

  callGtag('event', eventName, payload)
}

export const trackGa4PageView = (path, getState = null) => {
  if (!isAnalyticsEnabled()) return

  const pagePath = path || (typeof window !== 'undefined'
    ? window.location.pathname + window.location.search
    : '')

  trackGa4Event('page_view', {
    page_path: pagePath,
    page_location: typeof window !== 'undefined' ? window.location.href : undefined,
    page_title: typeof document !== 'undefined' ? document.title : undefined,
  }, getState)
}
